<template>
  <section class="layout-section -bg-shade">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">Grille d’articles</h2>
      <p>
        La grille d’articles offre une structure claire et répétitive qui aide l’utilisateur à balayer visuellement
        l’information.
      </p>
    </div>

    <section class="card-article">
      <DemoGridArticlesSingle
        title="Lorem ispum dolor sit amet"
        tag="Article"
        icon="content-article"
        image="pexels-kindelmedia-7651545"
      />
      <DemoGridArticlesSingle
        title="Placerat ipsa commodo nostra repellenwdus, porwwta quasi vel auctower justo ddde"
        tag="Rapport annuel"
        icon="content-rapport"
        image="pexels-rethaferguson-3810792"
      />
      <DemoGridArticlesSingle
        title="Quae ornare sodales error dis ornare ullam mauris"
        tag="Dossier thématique"
        icon="content-file"
        image="pexels-fauxels-3182781"
      />
    </section>
  </section>
</template>

<script>
import DemoGridArticlesSingle from './DemoGridArticlesSingle.vue'

export default {
  name: 'DemoGridArticles',
  components: { DemoGridArticlesSingle }
}
</script>
